<template>
  <AgeVerificationCompleteBase
    iconSrc="/img/age_verification/exclamation_circle.svg"
    :iconAlt="$t('age_verification__complete__failure_title')"
    titleKey="age_verification__complete__failure_title"
  />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import AgeVerificationCompleteBase from './AgeVerificationCompleteBase.vue'

@Component({
  components: { AgeVerificationCompleteBase },
})
export default class AgeVerificationCompleteFailure extends Vue {}
</script>
